import React, { Component } from "react";
import {
  DataGrid,
  FilterRow,
  Editing,
  Column,
  Paging,
  Pager,
  FormItem,
  Lookup,
} from "devextreme-react/data-grid";
import uiInfo from "../../ui-info";
import PaginaToolbar from "../../components/PaginaToolbar";
import {
  criarLcp116Prefeitura,
  criarCategoriaLcp116Prefeitura,
} from "../../DataSources";

const localStorageKey = "cadastroLcp116PrefeituraGridState";

export default class Lcp116PrefeituraBox extends Component {
  constructor() {
    super();
    this._gridInstance = React.createRef();
    this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
  }

  onAtualizandoRow(e) {
    e.cancel = true;
    this.props.history.push("lcp116prefeitura/editar/" + e.data.id);
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <PaginaToolbar
            titulo="LCP 116 Prefeitura"
            novoCb={this.novoRegistro.bind(this)}
          >
            <DataGrid
              ref={(grid) => (this._gridInstance = grid)}
              dataSource={criarLcp116Prefeitura()}
              showBorders={true}
              rowAlternationEnabled={true}
              remoteOperations={true}
              columnAutoWidth={true}
              focusedRowEnabled={true}
              wordWrapEnabled={true}
              filterSyncEnabled={true}
              onEditingStart={this.onAtualizandoRow}
            >
              <FilterRow visible={true} />
              <Editing allowDeleting={true} allowUpdating={true} useIcons={true}/>
              <Column
                dataField={"id"}
                caption={"#"}
                allowEditing={false}
                alignment={"center"}
                width={80}
                visible={false}
              />
              <Column
                dataField={"prefeituraId"}
                caption={"Prefeitura"}
                visible={false}
              >
                <FormItem visible={false}></FormItem>
              </Column>
              <Column dataField={"codigo"} caption={"Código"}  width={80} alignment={"center"}/>
              <Column dataField={"descricao"} caption={"Descrição"} wordWrapEnabled={true} width={500}/>
              <Column dataField={"categoriaId"} caption={"Categoria"}>
                <Lookup
                  dataSource={criarCategoriaLcp116Prefeitura()}
                  valueExpr={"id"}
                  displayExpr={"descricao"}
                />
              </Column>
              <Column
                dataField={"localTributacao"}
                caption={"Local de Tributação"}
              >
                <Lookup
                  dataSource={[
                    { id: 0, descricao: "Local de Serviço" },
                    { id: 1, descricao: "Sede Prestador" },
                  ]}
                  valueExpr={"id"}
                  displayExpr={"descricao"}
                />
              </Column>
              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
              <Pager
                showPageSizeSelector={true}
                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
              />
            </DataGrid>
          </PaginaToolbar>
        </div>
      </React.Fragment>
    );
  }

  novoRegistro() {
    let gridState = this._gridInstance.instance.state();
    localStorage.setItem(localStorageKey, JSON.stringify(gridState));
    this.props.history.push("lcp116prefeitura/novo");
  }
}
